<script lang="ts" setup>
import { cva, type VariantProps } from 'class-variance-authority'

import { classMerge } from '../utils'

const adWrapperVariants = cva('', {
  variants: {
    slotName: {
      mobile_1: 'flex justify-center items-center w-full sm:hidden',
      mobile_2: 'flex justify-center items-center w-full sm:hidden',
      mobile_3: 'flex justify-center items-center w-full sm:hidden',
      mobile_4: 'flex justify-center items-center w-full sm:hidden',
      mobile_5: 'flex justify-center items-center w-full sm:hidden',
      mobile_6: 'flex justify-center items-center w-full sm:hidden',
      mobile_7: 'flex justify-center items-center w-full sm:hidden',
      mobile_8: 'flex justify-center items-center w-full sm:hidden',
      mobile_9: 'flex justify-center items-center w-full sm:hidden',
      mobile_10: 'flex justify-center items-center w-full sm:hidden',
      combined_desktop_ads: 'hidden flex flex-col items-center w-full sm:min-h-[122px] sm:mt-6 sm:py-4 sm:mb-8 sm:flex',
      wallpaper_1: 'hidden justify-center items-center sm:flex',
      superbanner_1: 'hidden justify-center items-center sm:flex',
      superbanner_2: 'hidden justify-center items-center w-full py-4 my-8 sm:flex',
      superbanner_3: 'hidden justify-center items-center w-full py-4 my-8 sm:flex',
      superbanner_4: 'hidden justify-center items-center w-full py-4 my-8 sm:flex',
      superbanner_5: 'hidden justify-center items-center w-full py-4 my-8 sm:flex',
      superbanner_6: 'hidden justify-center items-center w-full py-4 my-8 sm:flex',
      rectangle_1: 'hidden w-[300px] mt-4 mb-8 sm:block',
      rectangle_2: 'hidden w-[300px] mt-4 mb-8 sm:block',
      rectangle_3: 'hidden w-[300px] mt-4 mb-8 sm:block',
      rectangle_4: 'hidden w-[300px] mt-4 mb-8 sm:block',
      rectangle_5: 'hidden w-[300px] mt-4 mb-8 sm:block',
      rectangle_6: 'hidden w-[300px] mt-4 mb-8 sm:block',
      skyscraper_1: 'hidden absolute top-0 left-[100%] w-fit h-full z-1 lg:block',
      dmofooter_1: 'hidden justify-center items-center w-full py-4 my-8 sm:flex'
    },
    disableSpacing: {
      true: ''
    }
  },
  compoundVariants: [
    {
      slotName: ['mobile_1', 'mobile_2', 'mobile_3', 'mobile_4', 'mobile_5', 'mobile_6', 'mobile_7', 'mobile_8', 'mobile_9', 'mobile_10'],
      disableSpacing: false,
      class: 'py-2 my-6'
    },
    {
      slotName: ['mobile_1', 'mobile_2', 'mobile_3', 'mobile_4', 'mobile_5', 'mobile_6', 'mobile_7', 'mobile_8', 'mobile_9', 'mobile_10'],
      disableSpacing: true,
      class: 'float-left'
    }
  ]
})

type AdWrapperProps = VariantProps<typeof adWrapperVariants>

withDefaults(
  defineProps<{
    twClass?: string,
    slotName: AdWrapperProps['slotName'],
    minWidth?: string,
    minHeight?: string,
    disableSpacing?: boolean
  }>(),
  {
    twClass: '',
    minWidth: undefined,
    minHeight: undefined,
    disableSpacing: false
  }
)
</script>

<template>
  <div :style="{ minWidth: minWidth ?? undefined, minHeight: minHeight ?? undefined }"
       :class="classMerge(adWrapperVariants({ slotName, disableSpacing }), twClass, 'box-content')">
    <slot />
  </div>
</template>
